import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgIf} from '@angular/common';
import {AccountLibraryModule, Subscription, User, environmentDev} from '@bellabeat/account-library';
import {UserService} from '../../../../../../chat-common/src/lib/services/user.service';

@Component({
  selector: 'app-subscription',
  standalone: true,
  imports: [
    NgIf,
    AccountLibraryModule
  ],
  templateUrl: './subscription.component.html',
  styleUrl: './subscription.component.scss'
})
export class SubscriptionComponent {
  @Output() dismiss: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onPaymentSuccess: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() isVisible: boolean = false;
  @Input() contentId: string;
  @Input() source: string;
  @Input() hideHeader: boolean = false;

  step: number = 0;
  selectedSubscription!: Subscription;
  user!: User;

  constructor(private userService: UserService) {
  }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    // set user here
    this.user = {
      id: this.userService.user.id,
      email: this.userService.user.email,
      name: this.userService.user.username,
    };
    this.selectedSubscription = environmentDev.subscriptions[0];
  }

  proceedToPayment($event: Subscription): void {
    this.selectedSubscription = $event;
    this.step++;
  }

  success(): void {
    this.step++;
    this.userService.updatePaymentStatus(true);
    // this.userService.sendAnalyticsEvent(this.selectedSubscription, this.source, this.contentId);
    setTimeout(() => {
      this.close();
      window.location.reload();
    }, 3000);
  }

  close(): void {
    this.step = 0;
    this.dismiss.emit(true);
  }
}
